import { useEffect, useState } from 'react'
import { useAuthStore } from '@/stores/authStore'

/**
 * 전역 동시접속자 수 훅.
 * - 로그인 시: 자신의 프레즌스를 등록하고 고유 접속 사용자 수를 실시간 구독.
 * - 비로그인/오류 시: null 반환 (배지 숨김).
 */
export function useOnlineUsers(): number | null {
  const uid = useAuthStore((s) => s.user?.uid)
  const [count, setCount] = useState<number | null>(null)

  useEffect(() => {
    if (!uid) {
      setCount(null)
      return
    }

    let disposed = false
    const cleanups: Array<() => void> = []

    import('@/services/presenceService')
      .then(async ({ registerGlobalPresence, subscribeOnlineCount }) => {
        if (disposed) return
        const unregister = await registerGlobalPresence()
        if (disposed) {
          unregister()
          return
        }
        cleanups.push(unregister)

        const unsubCount = await subscribeOnlineCount((n) => {
          if (!disposed) setCount(n)
        })
        if (disposed) {
          unsubCount()
          return
        }
        cleanups.push(unsubCount)
      })
      .catch(() => {
        /* RTDB 미구성 등 — 배지 숨김 유지 */
      })

    return () => {
      disposed = true
      cleanups.forEach((fn) => fn())
      cleanups.length = 0
      setCount(null)
    }
  }, [uid])

  return count
}
